import { render } from "./CompanyRegistrationCompleted.vue?vue&type=template&id=e340bfe6&ts=true"
import script from "./CompanyRegistrationCompleted.vue?vue&type=script&lang=ts"
export * from "./CompanyRegistrationCompleted.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__